// Components
import NavigationItem, {
  NavigationLink,
} from 'layouts/ProfileNavigation/components/NavigationSection/components/NavigationItem/NavigationItem';
// UI
import Text from 'ui3/Text/Text';
// Styles
import styles from './NavigationSection.module.scss';

type NavigationSectionProps = {
  title?: string;
  links: NavigationLink[];
};

const NavigationSection = ({ title, links }: NavigationSectionProps) => {
  return (
    <section className={styles.root}>
      {title && (
        <Text variant="body3Medium" color="lights-low" className={styles.title}>
          {title}
        </Text>
      )}

      <ul className={styles.list}>
        {links.map((item) => {
          return <NavigationItem key={item.label} item={item} />;
        })}
      </ul>
    </section>
  );
};

export default NavigationSection;
